import { ProductSpecification } from "@repo/components";
import { Prose } from "@repo/ui";

export const getTabItems = (description, glance, highlights, productOptions) =>
  [
    glance && {
      title: "At_A_Glance",
      content: <Prose html={glance} customClass="product-glance" />,
    },
    description && {
      title: "Description",
      content: <Prose html={description} />,
    },
    !!productOptions?.length && {
      title: "Specifications",
      content: <ProductSpecification productOptions={productOptions} />,
    },
    highlights && {
      title: "Highlights",
      content: <Prose html={highlights} customClass="product-highlight" />,
    },
  ].filter(Boolean);

export const getBreadCrumbs = (
  categoryName,
  name,
  categorySlug,
  productSlug,
  t
) => {
  const breadcrumbs = [{ label: t("Home"), url: "/" }];
  if (categorySlug) {
    breadcrumbs.push({
      label: categoryName,
      url: `/collections/${categorySlug}`,
    });
  }
  breadcrumbs.push({
    label: name,
    url: `/${productSlug}`,
  });
  return breadcrumbs;
};
